import React, { ChangeEvent } from 'react';
import Col from '../Col';
import { Heading } from '../Form';
import Input from '../Input';
import Select from '../Select';
import Row from '../Row';
import File from '../File';
import Checkbox from '../Checkbox';
import Button from '../Button';
import Picker from '../Picker';
import { SortIcon } from '../HomeOwnerDashboard/HomeownerOnboarding/SortIcon';
import { onCheckDocument } from 'src/helpers/CommonHelpers';
import { variables } from 'src/Tenants';

const PropertyDetailsForm = ({
  propertyFormData,
  onSetPropertyFormData,
  errors,
  onErrorEmpty,
  location,
  getLocation,
  predictions,
  onClickLocation,
  filteredPropertyManagers,
  strataManagers,
  tabList,
  selectedModulePermissions,
  onSetModules,
  propertyStages,
  propertyStatuses,
  onhandleStatusUpdate,
  onhandleStatusDelete,
  setSequence,
  onChangeRank,
  filterData,
  onAddNewConstructionStatus,
}: any) => {
  return (
    <Row mdCenter>
      <Col xs="12" md="6">
        <Heading>Property Details</Heading>
        <Input
          value={propertyFormData.name}
          onChange={(e) => onSetPropertyFormData({ name: e.target.value })}
          label="Property Name"
          required
          placeholder="eg., Example Property"
          block
          errors={errors.name}
        />
        <Select
          value={
            propertyFormData.propertyManagerId &&
            propertyFormData.propertyManagerId !==
              '00000000-0000-0000-0000-000000000000'
              ? propertyFormData.propertyManagerId
              : propertyFormData.propertyManager &&
                  propertyFormData.propertyManager.id
                ? propertyFormData.propertyManager.id
                : ''
          }
          onChange={(e: any) =>
            onSetPropertyFormData({
              propertyManagerId: e.target.value,
              propertyManager: {},
            })
          }
          options={filteredPropertyManagers.map((propertyManager: any) => ({
            value: propertyManager.id,
            label: `${propertyManager.firstname} ${propertyManager.lastname}`,
          }))}
          label={variables.propertyDeveloper}
          placeholder={'(Select ' + variables.propertyDeveloper + ')'}
          block
        />
        <Select
          value={
            propertyFormData.strataManagerId
              ? propertyFormData.strataManagerId
              : propertyFormData.strataManager &&
                  propertyFormData.strataManager.id
                ? propertyFormData.strataManager.id
                : ''
          }
          onChange={(e) =>
            onSetPropertyFormData({ strataManagerId: e.target.value })
          }
          options={strataManagers.map((strataManager: any) => ({
            value: strataManager.id,
            label: `${strataManager.firstname} ${strataManager.lastname}`,
          }))}
          label="Strata Manager"
          placeholder="(Select Strata Manager)"
          required={false}
          block
        />
        <Input
          value={location}
          onChange={(e: any) => getLocation(e.target.value)}
          label="Search Location"
          block
          placeholder="Search Location"
        />
        {predictions.map((item: any, i: any) => (
          <div
            key={i}
            className="location_search"
            onClick={() => onClickLocation(item.description)}
          >
            {item.description}
          </div>
        ))}
        <Input
          value={propertyFormData.addressLine1}
          onChange={(e) =>
            onSetPropertyFormData({ addressLine1: e.target.value })
          }
          label="Address"
          required
          placeholder="eg., 123 Example Street"
          block
          errors={errors.addressLine1}
        />

        <Row>
          <Col xs="12" md="4">
            <Input
              value={propertyFormData.city}
              onChange={(e: any) =>
                onSetPropertyFormData({ city: e.target.value })
              }
              label="City"
              required
              placeholder="eg., Vancouver"
              block
              errors={errors.city}
            />
          </Col>
          <Col xs="12" md="4">
            <Input
              value={propertyFormData.province}
              onChange={(e: any) =>
                onSetPropertyFormData({ province: e.target.value })
              }
              label="Province"
              required
              placeholder="eg., BC"
              block
              errors={errors.province}
            />
          </Col>
          <Col xs="12" md="4">
            <Input
              value={propertyFormData.postalCode}
              onChange={(e: any) => {
                onErrorEmpty('postalCode');
                return onSetPropertyFormData({
                  postalCode: e.target.value,
                });
              }}
              label="Postal Code"
              required
              placeholder="eg., A0A 0A0"
              block
              errors={errors.postalCode}
            />
          </Col>
        </Row>
        <label className="input__label">
          Permissions<span style={{ color: 'red' }}>*</span>
        </label>
        <br />
        <Row>
          {tabList.map((item) => {
            let result =
              selectedModulePermissions.length > 0
                ? selectedModulePermissions.find(
                    (object) => object.Id === item.id
                  )
                : null;
            let resultId =
              result === undefined || result === null
                ? null
                : result && result.Id
                  ? result.Id
                  : null;

            return (
              <Col key={item.id} xs="12" sm="12" md="6" lg="6">
                <Checkbox
                  checked={resultId === item.id}
                  name={resultId === item.id ? resultId : null}
                  value={resultId === item.id ? resultId : ''}
                  label={item.name}
                  onChange={() => onSetModules(item.id)}
                />
              </Col>
            );
          })}
        </Row>
        <File
          label="Image"
          onSelect={(file) => {
            onCheckDocument(file) &&
              onSetPropertyFormData({ selectedImage: file });
          }}
          files={
            propertyFormData.selectedImage ? propertyFormData.selectedImage : []
          }
          image={propertyFormData.image}
          errors=""
          type="image"
        />
        <label className="input__label">Construction Status</label>
        {propertyFormData?.constructionStages?.length > 0 &&
          propertyFormData.constructionStages.map((ps: any, i: any) => (
            <div
              key={i}
              className="propertyForm"
              draggable={true}
              onDragStart={() => setSequence(ps)}
              onDrop={() => onChangeRank(ps, i)}
            >
              <div className="construction">
                <div className="construction1">
                  <div className="construction2">
                    <div className="imageContainer">
                      <div style={{ paddingLeft: 25 }}>
                        <SortIcon />
                      </div>
                    </div>
                    <div className="stageContainer">
                      <label>
                        Select Stage<span style={{ color: 'red' }}>*</span>
                      </label>
                      <select
                        className="stages"
                        defaultValue=""
                        value={
                          ps && ps.new
                            ? propertyFormData.selectedStage || ''
                            : ps.id && ps.type === 'Custom Stage'
                              ? ps.type
                              : ps.id || ps.type
                        }
                        onChange={(e: any) =>
                          ps && ps.new
                            ? e.target.value === 'Custom Stage'
                              ? onSetPropertyFormData({
                                  selectedStage: e.target.value,
                                  isCustomStageEnabled: true,
                                })
                              : onSetPropertyFormData({
                                  selectedStage: e.target.value,
                                  isCustomStageEnabled: false,
                                })
                            : onhandleStatusUpdate(e.target.value, i, 'id')
                        }
                      >
                        <option value="" disabled>
                          Select stage
                        </option>
                        {[
                          ...propertyStages,
                          { id: 'Custom Stage', name: 'Custom Stage' },
                        ].map((stage, index) => (
                          <option key={index} value={stage.id}>
                            {stage.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    {((propertyFormData?.selectedStage === 'Custom Stage' &&
                      !ps.id) ||
                      ps.type === 'Custom Stage' ||
                      (ps.id && ps.type === 'Custom Stage')) && (
                      <div className="stageContainer">
                        <input
                          placeholder="Custom stage"
                          type="text"
                          className="custominput"
                          value={
                            ps && ps.new
                              ? propertyFormData.customStageName || ''
                              : ps.name
                          }
                          onChange={(e: ChangeEvent<HTMLInputElement>) =>
                            ps && ps.new
                              ? onSetPropertyFormData({
                                  customStageName: e.target.value,
                                })
                              : onhandleStatusUpdate(e.target.value, i, 'name')
                          }
                        />
                      </div>
                    )}
                    <div
                      className="stageContainer"
                      style={{ paddingRight: '0px' }}
                    >
                      <label>
                        Status<span style={{ color: 'red' }}>*</span>
                      </label>
                      <select
                        className="stages"
                        defaultValue=""
                        value={
                          ps && ps.new
                            ? propertyFormData.selectedStatus || ''
                            : ps.statusId
                        }
                        onChange={(e: any) =>
                          ps && ps.new
                            ? onSetPropertyFormData({
                                selectedStatus: e.target.value,
                              })
                            : onhandleStatusUpdate(
                                e.target.value,
                                i,
                                'statusId'
                              )
                        }
                      >
                        <option value="" disabled>
                          Status
                        </option>
                        {propertyStatuses.map((status: any, index: any) => (
                          <option key={index} value={status.id}>
                            {status.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div
                      className="crossContainer"
                      style={{ cursor: 'pointer' }}
                    >
                      <img
                        src="/assets/cross.png"
                        style={{ marginTop: '7px', width: '18px' }}
                        onClick={() =>
                          window.confirm(
                            'Are you sure you want to delete construction stage?'
                          ) && onhandleStatusDelete(i, ps)
                        }
                        alt="Delete"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="dateContainer">
                <div className="dateContainer3">
                  <Picker
                    placeholderText="Date"
                    required={false}
                    showPopperArrow={false}
                    selected={
                      ps && ps.new
                        ? propertyFormData.selectedDate || null
                        : ps.date && ps.date === '0001-01-01T00:00:00+00:00'
                          ? null
                          : ps.date
                            ? new Date(ps.date)
                            : null
                    }
                    onChange={(date) =>
                      ps && ps.new
                        ? onSetPropertyFormData({ selectedDate: date })
                        : onhandleStatusUpdate(date, i, 'date')
                    }
                    label={undefined}
                  />
                </div>
              </div>
            </div>
          ))}
        <div style={{ marginTop: 10 }}>
          <Button
            color="teal"
            size="small"
            label="+ Add New Construction Status"
            onClick={() =>
              onAddNewConstructionStatus(
                !(
                  !propertyFormData.selectedStatus ||
                  !propertyFormData.selectedStage
                )
              )
            }
            disabled={
              filterData && filterData.length > 0
                ? !propertyFormData.selectedStatus ||
                  (propertyFormData?.selectedStage === 'Custom Stage' &&
                    !propertyFormData.customStageName) ||
                  !propertyFormData.selectedStage
                : false
            }
          />
        </div>
      </Col>
    </Row>
  );
};

export default PropertyDetailsForm;
